var map = {
	"./atp.png": "4c5UdVLI",
	"./atp_challenger_series.png": "3vaqbdIr",
	"./exhibition_matches.png": "6BoDkdZf",
	"./grand_slam.png": "vuImMmXL",
	"./itf_men.png": "8b7IwPi8",
	"./itf_women.png": "eVehcAMB",
	"./teams.png": "KRHRrFKH",
	"./wta.png": "W5l0Bh2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DwyjFzgM";